/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { getApiHost } from 'cio/utils/data-centers';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import EnvironmentService from 'cio/services/environment';
import CustomForm from 'cio/models/custom-form';

interface FormsCustomIntegrationDetailsFormsEndpointArgs {
  form: CustomForm | null;
  onCopy: () => unknown;
  credentials?: {
    siteId?: string;
    apiKey?: string;
  };
}
export default class FormsCustomIntegrationDetailsFormsEndpoint extends Component<FormsCustomIntegrationDetailsFormsEndpointArgs> {
  @service account!: AccountService;
  @service environment!: EnvironmentService;

  get formId() {
    if (this.args.form == null) {
      return '{{form_id}}';
    }

    return this.args.form.formId;
  }

  get trackAPISubmitURL() {
    // eslint-disable-next-line no-useless-escape
    return `https:\/\/${getApiHost('track', this.account.current?.dataCenter ?? '')}.customer.io/api/v1/forms/${
      this.formId
    }/submit`;
  }

  get snippet() {
    let json = JSON.stringify({
      data: this.environment.current.canIdentifyByEmail ? { email: 'test@customer.io' } : { id: 'customer_id1' },
    });

    // prettier-ignore
    return `
curl --request POST \\
  --url ${this.trackAPISubmitURL} \\
  --header "Authorization: Basic $(echo -n \\
  ${this.args.credentials?.siteId ?? 'siteid'}:${this.args.credentials?.apiKey ?? 'apikey'} | base64)" \\
  --header 'content-type: application/json' \\
  --data '${json}'
`.trim();
  }
}
